/* eslint-disable no-unused-vars */
import React, { useState, useRef, useMemo, useEffect, useContext } from 'react'
import PageLayout from '@layouts/PageLayout'
import PropTypes from 'prop-types'
import { useLocalization } from '@contexts/LocalizationContext'
import { Input, Table, Dropdown, Button, message } from 'antd'
import Fetch from '@components/CRUD/Fetch'
import { EllipsisOutlined } from '@ant-design/icons'
// import Create from './Create'
import { client } from '@utils/client'
// import Edit from './Edit'
import { PlusCircleOutlined, DownloadOutlined } from '@ant-design/icons'
import Text from '@components/Text'
import AddMember from './AddMember'
import SuspendAccount from './SuspendAccount'
import DetailMember from './DetailMember'
import { ThemeContext } from '@contexts/ThemeContext'
import dayjs from 'dayjs'

export const wellKidzClubMember = 'wellKidzClub.member'
export const wellKidzClubButton = 'wellKidzClub.button'
export const wellKidzClubModal = 'wellKidzClub.modal'
export const wellKidzClubError = 'wellKidzClub.error'
export const getStatusWellKidzClubMember = (statusAcc, color, t) => {
  switch (statusAcc) {
    case 'EXPIRED':
      return (
        <Text strong color={color.black}>
          {t(`${wellKidzClubMember}.status.expired`)}
        </Text>
      )
    case 'RENEWED':
      return (
        <Text strong color={color.success}>
          {t(`${wellKidzClubMember}.status.renewed`)}
        </Text>
      )
    case 'BANNED':
      return (
        <Text strong color={color.danger}>
          {t(`${wellKidzClubMember}.status.suspended`)}
        </Text>
      )
    default:
      return (
        <Text strong color={color.success}>
          {t(`${wellKidzClubMember}.status.active`)}
        </Text>
      )
  }
}
const List = () => {
  const { t } = useLocalization()
  const defaultPage = 1
  const defaultPageSize = 10
  const fetchRef = useRef(null)
  const [page, setpage] = useState(defaultPage)
  const [pageSize, setpageSize] = useState(defaultPageSize)

  const [keyword, setKeyword] = useState()
  const [openDetailMember, setOpenDetailMember] = useState(false)
  const [openAddMember, setOpenAddMember] = useState(false)
  const [openSuspendAccount, setOpenSuspendAccount] = useState(false)
  const [dataRecord, setDataRecord] = useState({})
  const { theme } = useContext(ThemeContext)
  const memoizedParams = useMemo(
    () => ({ page, pageSize, keyword }),
    [page, pageSize, keyword]
  )
  const fetch = async ({ page, pageSize, keyword }) => {
    const result = await client
      .get('/wellkidzclub', {
        params: {
          page: page,
          limit: pageSize,
          search: keyword,
          status: '',
        },
      })
      .then((res) => res.data)

    return result
  }
  const unsuspendAccount = async (id) => {
    try {
      await client.patch(`/wellkidzclub/${id}/status`, {
        status: 'ACTIVE',
      })
      message.success('สำเร็จ')
      handleReload()
    } catch (e) {
      message.error('ไม่สำเร็จ')
    }
  }
  const columns = [
    {
      title: 'No.',
      key: 'order',
      width: 62,
      render: function get(_value, _record, index) {
        return <Text> {(page - 1) * defaultPageSize + index + 1}</Text>
      },
    },
    {
      title: t(`${wellKidzClubMember}.fullName`),
      key: 'fullname',
      width: 300,
      render: function get(record) {
        const { firstname, lastname } = record.profile
        return <Text>{`${firstname} ${lastname}`} </Text>
      },
    },
    {
      title: t(`${wellKidzClubMember}.yearsOld`),
      dataIndex: 'age',
      key: 'age',
      width: 80,
    },
    {
      title: t(`${wellKidzClubMember}.hospitalNo`),
      key: 'hospitalNo',
      width: 180,
      render: function get(record) {
        return <Text>{record.hns.length > 0 ? record.hns[0] : '-'} </Text>
      },
    },
    {
      title: t(`${wellKidzClubMember}.id`),
      key: 'id',
      width: 130,
      render: function get(record) {
        const { id } = record.profile
        return <Text>{id} </Text>
      },
    },
    {
      title: t(`${wellKidzClubMember}.expDate`),
      // dataIndex: 'expireAt',
      key: 'expireAt',
      width: 195,
      render: function get(record) {
        const { expiredAt } = record
        return (
          <Text>{dayjs(expiredAt).locale('th').format('DD MMM YYYY')} </Text>
        )
      },
    },
    {
      title: t(`${wellKidzClubMember}.status.label`),
      key: 'status',
      width: 165,
      render: function get(record) {
        const { statusAcc } = record
        return getStatusWellKidzClubMember(statusAcc, theme.text, t)
      },
    },
    {
      title: '',
      key: 'edit',
      width: 61,
      render: function get(record) {
        const items = [
          {
            key: '1',
            label: (
              <a
                onClick={() => {
                  setOpenDetailMember(true)
                  setDataRecord(record)
                }}
              >
                <Text type="primary">ดูข้อมูล</Text>
              </a>
            ),
          },
          {
            type: 'divider',
          },
          {
            key: '2',
            label:
              record.statusAcc === 'BANNED' ? (
                <a
                  onClick={() => {
                    unsuspendAccount(record.id)
                  }}
                >
                  <Text type="primary">
                    {t(`${wellKidzClubButton}.unsuspendAccount`)}
                  </Text>
                </a>
              ) : (
                <a
                  onClick={() => {
                    setOpenSuspendAccount(true)
                    setDataRecord(record)
                  }}
                >
                  <Text type="danger">
                    {t(`${wellKidzClubButton}.suspendAccount`)}
                  </Text>
                </a>
              ),
          },
        ]
        return (
          <>
            <div>
              <Dropdown
                menu={{
                  items,
                }}
                trigger="click"
              >
                <EllipsisOutlined
                  style={{ fontSize: '32px', color: '#005596' }}
                />
              </Dropdown>
            </div>
          </>
        )
      },
    },
  ]
  const handleReload = () => {
    fetchRef.current.reload()
    setOpenSuspendAccount(false)
    setOpenDetailMember(false)
    setOpenAddMember(false)
  }

  const handleChange = (pagination) => {
    setpage(pagination.current)
    setpageSize(pagination.pageSize)
  }
  const iconSize = { fontSize: 18 }
  const style = {
    btn: { borderRadius: '5px', width: 'max-content', height: '40px' },
    divSearch: {
      width: '100%',
      display: 'flex',
      gap: '20px',
      marginBottom: '20px',
    },
    btnSearch: { borderRadius: '5px', width: '136px', height: '40px' },
    inputSearch: { width: '100%', borderRadius: '6px', height: '40px' },
  }

  const onDownload = async () => {
    const { data } = await client.get(`/wellkidzclub/excel`, {
      responseType: 'blob',
    })
    const url = window.URL.createObjectURL(new Blob([data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', 'Member.xlsx')
    document.body.appendChild(link)
    link.click()
  }

  return (
    <>
      <Fetch fetch={fetch} params={memoizedParams} ref={fetchRef}>
        {({ data, total }) => (
          <>
            <PageLayout
              title={t(`${wellKidzClubMember}.title`)}
              shownBack={false}
              extra={[
                // <Button
                //   type="primary"
                //   key="btnDownloadTemplate"
                //   icon={<DownloadOutlined style={iconSize} />}
                //   onClick={() => {
                //     window.location.href = `${process.env.PUBLIC_URL}/assets/wellKidClub-member-template.xlsx`
                //   }}
                //   style={style.btn}
                // >
                //   {t(`${wellKidzClubButton}.downloadTemplate`)}
                // </Button>,
                // <Button
                //   type="primary"
                //   key="btnAddData"
                //   icon={<PlusCircleOutlined style={iconSize} />}
                //   onClick={() => setOpenAddMember(true)}
                //   style={style.btn}
                // >
                //   {t(`${wellKidzClubButton}.addDataMember`)}
                // </Button>,

                <Button
                  type="primary"
                  key="btnDownloadReport"
                  icon={<DownloadOutlined style={iconSize} />}
                  onClick={() => {
                    onDownload()
                  }}
                  style={style.btn}
                >
                  {t(`${wellKidzClubButton}.downloadReport`)}
                </Button>,
              ]}
            >
              <div style={style.divSearch}>
                <SearchInput
                  keywordValue={keyword}
                  fetchData={(keyword) => setKeyword(keyword)}
                />
              </div>

              <Table
                rowKey="id"
                columns={columns}
                dataSource={data}
                onChange={handleChange}
                pagination={{
                  defaultCurrent: 1,
                  defaultPageSize: defaultPageSize,
                  current: page,
                  pageSize,
                  total,
                }}
              ></Table>
            </PageLayout>
          </>
        )}
      </Fetch>
      {openDetailMember && (
        <DetailMember
          id={dataRecord.id}
          wellClubId={dataRecord.id}
          dataMember={dataRecord}
          open={openDetailMember}
          setOpen={setOpenDetailMember}
          setConfirm={setOpenSuspendAccount}
          unsuspendAccount={unsuspendAccount}
        />
      )}
      {openAddMember && (
        <AddMember open={openAddMember} setOpen={setOpenAddMember} />
      )}

      {openSuspendAccount && (
        <SuspendAccount
          wellClubId={dataRecord.id}
          open={openSuspendAccount}
          setOpen={setOpenSuspendAccount}
          reload={handleReload}
        />
      )}
    </>
  )
}
const SearchInput = ({ fetchData, keywordValue }) => {
  const { t } = useLocalization()
  const [keyword, setKeyword] = useState()
  const style = {
    btnSearch: { borderRadius: '5px', width: '136px', height: '40px' },
    inputSearch: { width: '100%', borderRadius: '6px', height: '40px' },
  }

  return (
    <>
      <Input
        defaultValue={keywordValue || keyword}
        placeholder="ค้นหาชื่อ, Hospital No., หรือ รหัสสมาชิก"
        style={style.inputSearch}
        onChange={(e) => setKeyword(e.target.value)}
      />

      <Button
        style={style.btnSearch}
        type="primary"
        key="reload"
        onClick={() => fetchData(keyword)}
      >
        {t(`${wellKidzClubButton}.search`)}
      </Button>
    </>
  )
}

SearchInput.propTypes = {
  fetchData: PropTypes.func,
  keywordValue: PropTypes.string,
}
export default List
